// 用户存，流程导航
<template>
  <div class="flow userSaveFlow">
    <ul
      class="nav"
      :style="{backgroundPositionY: -(index-1) + 'rem'}">
      <li class="li" :class="{active : index == 1}">1. 请扫描您的员工卡<span></span></li>
      <li class="li" :class="{active : index == 2}">2. 选择箱格大小</li>
      <li class="li" :class="{active : index == 3}">3. 选择取件人</li>
      <li class="li" :class="{active : index == 4}">4. 存入物品完成</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'userSaveFlow',
  props: ['index'],
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  },
  watch: {
  }
}
</script>

<style scoped>
.flow.userSaveFlow .nav{
  width: 15.64rem;
  background-image: url(/../static/turnoverCabinet/images/flow/userSaveFlow.png);
  background-repeat: no-repeat;
  background-position-x: 0;
  background-size: 15.64rem 4rem;
}

.flow.userSaveFlow .nav .li {
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/turnoverCabinet/userSave/userSaveFlow.vue